module.exports = __webpack_public_path__ + "static/media/masters_thesis20.3900e2fa.webp";